import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202101260017', { defaultText: '条码' }),
                align: 'center',
                prop: 'barcodeNo',
                value: '',
                filter: true,
                require: true,
                fixed: 'left',
                sort: true,
                width: 190
            },
            {
                label: $translate('lang.E3202101260015', { defaultText: '当前节点名称' }),
                align: 'center',
                prop: 'orgName',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E3202101260016', { defaultText: '产品编码' }),
                align: 'center',
                prop: 'itemCode',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E3202101260018', { defaultText: '产品名称' }),
                align: 'center',
                prop: 'itemName',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 180
            },
            {
                label: $translate('lang.E3202101260019', { defaultText: '工厂名称' }),
                align: 'center',
                prop: 'mesName',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202101260020', { defaultText: '总部仓库' }),
                align: 'center',
                prop: 'hqInventory',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 130
            },
            {
                label: $translate('lang.E3202101260021', { defaultText: '销售公司名称' }),
                align: 'center',
                prop: 'salesCenterName',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 140
            },
            {
                label: $translate('lang.E3202101260022', { defaultText: '经销商名称' }),
                align: 'center',
                prop: 'customerName',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 140
            },
            {
                label: $translate('lang.E3202101260023', { defaultText: '消费者' }),
                align: 'center',
                prop: 'consumer',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 100
            },
            {
                label: $translate('lang.E3202101260024', { defaultText: '数量' }),
                align: 'center',
                prop: 'quantity',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 100
            },
            {
                label: $translate('lang.E3202101260025', { defaultText: '生产日期' }),
                align: 'center',
                prop: 'prodDate',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202101260026', { defaultText: '入库日期' }),
                align: 'center',
                prop: 'inDate',
                value: '',
                filter: true,
                require: true,
                sort: true,
                width: 90
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
